<template>
  <div class="app" :class="{ dark: mode == 'dark', school: mode == 'school' }">
    <div
      style="z-index: -1"
      class="absolute inset-x-0 top-0 overflow-hidden pl-[50%]"
    >
      <img
        src="/img/bg.png"
        alt=""
        class="-ml-[39rem] md:w-[113.125rem] max-w-none"
      />
    </div>

    <router-view :dpi="dpi" :device="device"></router-view>

    <div class="nav items-center">
      <router-link to="/" class="text-indigo-500 hover:text-indigo-300"
        >Home</router-link
      >

      <ul
        class="md:scale-75 md:-mt-4 ml-2 flex share-buttons"
        data-source="simplesharingbuttons.com"
      >
        <li class="mr-2 md:mr-3 opacity-10 hover:opacity-100">
          <a
            href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fonlineruler.io&quote=Online%20Ruler%20-%20Free%20online%20ruler%20tool!"
            title="Share on Facebook"
            target="_blank"
            ><img
              alt="Share on Facebook"
              src="/img/social_flat_rounded_rects_svg/Facebook.svg"
          /></a>
        </li>
        <li class="mr-2 md:mr-3 opacity-20 hover:opacity-100">
          <a
            href="https://twitter.com/intent/tweet?source=https%3A%2F%2Fonlineruler.io&text=Online%20Ruler%20-%20Free%20online%20ruler%20tool!:%20http%3A%2F%2Fonlineruler.io"
            target="_blank"
            title="Tweet"
            ><img
              alt="Tweet"
              src="/img/social_flat_rounded_rects_svg/Twitter.svg"
          /></a>
        </li>
        <li class="mr-2 md:mr-3 opacity-20 hover:opacity-100">
          <a
            href="http://pinterest.com/pin/create/button/?url=https%3A%2F%2Fonlineruler.io&media=https://www.onlineruler.io/img/onlineruler.jpg&description=A%20free%20online%20ruler%20tool%20that%20works%20on%20any%20device%2C%20and%20automatically%20scales%20based%20on%20your%20screen%20size%20and%20DPI.%20Measure%20with%20confidence%20for%20free%2C%20anytime%2C%20anywhere!"
            target="_blank"
            title="Pin it"
            ><img
              alt="Pin it"
              src="/img/social_flat_rounded_rects_svg/Pinterest.svg"
          /></a>
        </li>
        <li class="mr-2 md:mr-0 opacity-20 hover:opacity-100">
          <a
            href="mailto:?subject=Online%20Ruler%20-%20Free%20online%20ruler%20tool!&body=A%20free%20online%20ruler%20tool%20that%20works%20on%20any%20device%2C%20and%20automatically%20scales%20based%20on%20your%20screen%20size%20and%20DPI.%20Measure%20with%20confidence%20for%20free%2C%20anytime%2C%20anywhere!:%20https%3A%2F%2Fonlineruler.io"
            target="_blank"
            title="Send email"
            ><img
              alt="Send email"
              src="/img/social_flat_rounded_rects_svg/Email.svg"
          /></a>
        </li>
      </ul>

      <router-link to="/about" class="text-indigo-500 hover:text-indigo-300"
        >About</router-link
      >
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "App",
  data() {
    return {
      mode: "light",
    };
  },
  setup() {
    let dpi = ref(100);
    let device = ref(null);

    // Fetch the JSON data
    fetch("data.json")
      .then((response) => response.json())
      .then((data) => {
        let filteredDevices = data.data;

        // Filter by User Agent
        if (navigator.userAgent.match(/iPhone/i)) {
          filteredDevices = filteredDevices.filter((device) =>
            device.Name.includes("iPhone")
          );
        } else if (navigator.userAgent.match(/OS X|OSX|Macintosh|Macbook/i)) {
          filteredDevices = filteredDevices.filter((device) =>
            device.Name.includes("Mac")
          );
        }
        // Add additional conditions for other devices as needed
        // else if(navigator.userAgent.match(/OTHER_DEVICE_REGEX/i)) {
        //     filteredDevices = filteredDevices.filter(device => device.Name.includes('OTHER_DEVICE_NAME'));
        // }

        console.log("Potential devices = ", filteredDevices);

        // Attempt an exact match using screen dimensions
        device.value = filteredDevices.find((device) => {
          return (
            window.screen.width === device.viewportWidth &&
            window.screen.height === device.viewportHeight
          );
        });

        if (device.value) {
          let dppi = device.value.densityPPI / device.value.pixelRatio;
          //const displayArea = document.getElementById("deviceInfo");
          //displayArea.innerHTML =
          console.log(JSON.stringify(device, null, 2) + "<br />DPPI = " + dppi);

          dpi.value = dppi;
        } else {
          //displayArea.textContent = "No exact match found.";
        }
      })
      .catch((error) => {
        console.error("Error fetching or processing data:", error);
      });

    return {
      dpi,
      device: device,
    };
  },
};
</script>

<style>
body {
  margin: 0;
  /* background-image: url(http://bradjasper.com/subtle-patterns-bookmarklet/patterns/whitediamond.png); */
  background-repeat: repeat;
  background-size: auto;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.app.dark {
  color: white;
  background: url(https://bradjasper.com/subtle-patterns-bookmarklet/patterns/outlets.png);
  background-repeat: repeat;
  background-size: auto;
}
.app.school {
  color: white;
  background: url(https://bradjasper.com/subtle-patterns-bookmarklet/patterns/pool_table.png);
  background-repeat: repeat;
  background-size: auto;
}

.nav {
  display: flex;
  justify-content: space-around;
}
.nav {
  padding: 2rem;
}
@media (max-width: 768px) and (orientation: portrait) {
  .nav {
    margin-left: 120px;
  }
  .fs {
    /* transform: rotate(90deg); */
    transform-origin: center;
  }
}

ul.share-buttons {
  list-style: none;
  padding: 0;
}

ul.share-buttons li {
  display: inline;
}

ul.share-buttons .sr-only {
  position: absolute;
  clip: rect(1px 1px 1px 1px);
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0;
  border: 0;
  height: 1px;
  width: 1px;
  overflow: hidden;
}

ul.share-buttons img {
  width: 32px;
}
</style>
